import React, {Component} from 'react';
import {INSPECTION_API_URL, REPORT_ACTIONS_API_URL} from "../../constants/api_routes";
import {BASE_URL} from "../../constants/app_routes";
import ReportContainer from '../../containers/report_container';
import RoomsListView from "./rooms_list";
import ReportTitlePage from "./report_titlepage";
import ScheduleOfCondition from './schedule_of_condition';
import PhotoLink from './photo_link';
import FloatingSideBarWidget from "./floating_sidebar_widget";
import ImageUploadProgress from "./image_upload";
import {changeInspectionStatus} from '../../data/inspection_api';
import AdditionalPhotos from "./additional_photos"
import {Button, Header, Segment,Confirm,Message,Grid, Icon,Popup,Image,Label} from 'semantic-ui-react';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import * as fileIcon from "../../assets/fileIcon.png";
import Keys from "./keys";
import Alarms from "./alarms";
import Meters from "./meters";
import Receipt from "./receipts";
import Depositary from './depositary';
import {handleFileDownload} from "../../utils/download_file";
import DownloadingIntent from "../universal/toast";
import LoadReport from "./initialize_report_from_old_report";
import DownloadReport from "./download_previous_reports";
import ClerkRoomTemplate from "./templates/clerk/clerk_room_template";
import RoomTemplateList from "./templates/clerk/room_template_list";
import LoginModal from "../universal/login_modal";
import {refreshUserToken} from "../../utils/validate_session_expiry"
import Loader from "../universal/loader";
import DisclaimerNotes from "./disclaimer_notes";
import AdditionalSummary from "./additional_summary_notes";
import OriginalReportDetails from "./original_report_details";
import AutoTranscription from "./auto_transcription";
import Checklist from './checklist';
import moment from 'moment';
// import RoomSort from "./room_sort";
class CreateReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reportId: this.props.match.params.reportId,
            rooms: [],
            uploadImages: false,
            showSelection: undefined,
            confirm:false,
            submitStatus:undefined,
            isDownloading:false,
            saveAsTemplate:undefined,
            showPasswordWindow:false,
            loginError:"",
            loggingin:false,
            showAdditionalPhotos:false,
            forceOverlay:false
        }
    }

    setUploadingImages = (startUpload) => {
        this.setState({uploadImages: startUpload});
    };

    componentWillMount() {
        this.props.getReportById(REPORT_ACTIONS_API_URL, this.state.reportId,this.successCallBack);
    }

    successCallBack = (status) => {
        if(status === 403){
            this.props.history.replace('/report/download/'+this.state.reportId);
        }
     };

    openSelection = (section) => {
        this.setState({showSelection: section});
    };

    handleClose = () => {
        this.setState({showSelection: undefined});
    };

    showSaveTemplate = (toShow,roomObject) => {
        this.setState({saveAsTemplate:toShow,roomSelectedForTemplate:roomObject});
    };

    showLoadTemplate = (toShow) => {
        this.setState({showRoomTemplate:toShow});
    };

    loadSelectedTemplate = async (roomTemplate) => {
        await this.props.loadNewRoomTemplate(roomTemplate);
        this.showLoadTemplate(false);
    };

    handleDownload = async () => {
        if(!this.state.isDownloading) {
            this.setState({isDownloading:true,showDownload:true});
            const URL = BASE_URL+"/report/download/"+this.state.reportId;
            const fileName = this.props.reportDetails['filename'];
            await handleFileDownload(URL,fileName);
            this.setState({isDownloading:false});
        }
    };

    handleLiabilityDownload = async () => {
        this.setState({isDownloading:true,showDownload:true});
        const URL = BASE_URL+"/export/liability/"+this.state.reportId;
        const fileName = `Suggested Costs ${this.props.reportDetails['filename']}.xlsx`;
        await handleFileDownload(URL,fileName);
        this.setState({isDownloading:false});
    };

    submitReport = () => {
        this.setState({submittingReport:true});
        if(this.state.submitStatus){
            const formData = {
                inspection_id: this.props.reportDetails['inspection_id'],
                status: this.state.submitStatus
            };
            changeInspectionStatus(INSPECTION_API_URL, formData).then((response) => {
                if (response.success) {
                    this.props.history.push('/inspection');
                }
                this.setState({submittingReport:true});
            })
        }
    };

    showEnterPasswordWindow = (show) => {
        this.setState({showPasswordWindow:show});
    };

    validateLogin = (email,password,otp_attempt) => {
        this.setState({loggingin:true});
        refreshUserToken(email,password,otp_attempt).then((res)=>{
            this.setState({loggingin:false});
            if(res.success){
                this.showEnterPasswordWindow(false);
            }
            else {
                this.setState({loginError:res.error,loggingin:false});
            }
        });
    };

    handleCancel = () => {
        this.setState({showConfirm:false,submitStatus:undefined})
    };

    render() {
        if(this.props.reportDetails['inspection_status'] > 6){
            this.props.history.replace('/report/download/'+this.props.match.params.reportId);
        }
        const reportDetails = this.props.reportDetails;
        return (<div className="pad-bottom">
            {this.state.submittingReport && <Loader save={true}/>}
            {this.state.showConfirm && <div><Confirm open={true} header="Confirm report submission" content="Report once submitted cannot be edited again" onCancel={this.handleCancel} onConfirm={this.submitReport} /></div>}
            {reportDetails &&
            <div className="pad-all header-sticky report-container">
                <Button primary className="pull-right" content="Download Report" onClick={this.handleDownload}/>
                {this.props.userRole === "clerk" &&
                <Button positive className="pull-right" content="Submit Report" onClick={() => {this.setState({submitStatus:"submitted"})
                this.openSelection("checklist")
            }} />}
                {this.props.userRole === "admin" && <Button primary className="pull-right" content="Checklist" onClick={()=>this.setState({showSelection:"checklist"})}/>}
                {this.props.userRole === "admin" &&
                        <Button positive className="pull-right" content="Complete Report" onClick={() => {
                            if (reportDetails['inspection_type'] == "co" && reportDetails["depositary_client_token"] && (!reportDetails["depositary_uploaded_deductions"] || !reportDetails["depositary_uploaded_checkout"]) ) {
                                this.openSelection("depositary")
                                this.setState({submitStatus:"completed"})
                            }
                            else {
                                this.setState({ showConfirm: true, submitStatus: "completed" })
                            }
                        }} />}
                        
                {this.props.userRole === "admin" &&
                        <Button className="pull-right" content="Liability List" onClick={this.handleLiabilityDownload}/>}
                <Header as='h3'
                        content={reportDetails['inspection_reference_id'] ? "Reference ID : " + reportDetails['inspection_reference_id'] : ""}
                        textAlign='left'/>
                <Header as='h3'
                        content={reportDetails['address'] ? "Address : " + reportDetails['address'].replace(/,+/g, ",") : ""}
                        textAlign='left'
                        style={{marginTop: '0'}}
                />
            </div>}
            <Segment className="report-container-responsive" style={{margin: 'auto'}}>
                {this.props.errorResponse && <Message negative header='Encountered an error while saving'
                content={this.props.errorResponse}></Message>}
                {reportDetails["report_requirements"] && <Message
                    header='Client Specific Info/Report Requirements'
                    content={reportDetails["report_requirements"].split("\n").map((value, index) => {return (<React.Fragment key={index}>{value}<br /></React.Fragment>);})}></Message>}
                {reportDetails.id && <Grid  stackable columns={2}>
                    <Grid.Row>
                        <Grid.Column>
                    {reportDetails["report_type"] !== "other" ?
                        <Segment style={{ width: "100%" }}  textAlign="center">{this.state.showLoadFromReport ?
                            <LoadReport reportId={reportDetails.id} inspectionType={reportDetails['inspection_type']} close={() => { this.setState({ showLoadFromReport: false }) }} /> : <Button primary content="Load Data From Previous Reports" onClick={() => { this.setState({ showLoadFromReport: true }) }} />
                            }<Message color='blue' >Click to select a report from the list to use as a basis for compiling a new report.<br/><strong>If compiling a Check Out, please ensure the latest Check In is selected when loading<br/><br/>
                            {reportDetails["loaded_ci_report"] && <Message><Message.Header>Currently Linked Report:</Message.Header>{`${reportDetails["loaded_ci_report"]["inspection_type"].toUpperCase()} from ${moment(reportDetails["loaded_ci_report"]["inspection_start_time"]).format("DD-MM-YYYY")}`}</Message>}
                            </strong></Message></Segment> : null}</Grid.Column>
                    <Grid.Column><Segment style={{ width: "100%" }}  textAlign="center">{this.state.showDownloadPreviousReports ?
                        <DownloadReport reportId={reportDetails.id}
                            inspectionType={reportDetails['inspection_type']}
                            close={() => { this.setState({ showDownloadPreviousReports: false }) }} />:<Button color="green" content="Download Previous Reports (PDF)" onClick={() => { this.setState({ showDownloadPreviousReports: true }) }} />}   <Message positive>Click to get the PDFs of previous reports done at this property.<br/><strong>When compiling a Check In following a recent Check Out, please download the Check Out and ensure the cleaning summaries match up with each other</strong></Message></Segment></Grid.Column>
                </Grid.Row></Grid>}
                                    {reportDetails['inspection_attachments'] && reportDetails['inspection_attachments'].length > 0 && <Segment  style={{margin:"auto"}}>
                        <Message><Message.Header>Inspection Attachments</Message.Header> Please check for and use original CI report documents if doing a CO, and include any cleaning invoices in the report. </Message>
                                                <Label color='blue' ribbon>
                                                    Inspection Attachments
                                                </Label>
                                                <p></p>
                                                <div className="center-aligned" style={{minHeight: '50px'}}>
                                                    <Image.Group size='small'>
                                                          {  reportDetails.inspection_attachments.map((image, i) => <Image key={i} as='a' target='_blank'   href={image.file}  src={image['content_type'] && image['content_type'].match(/image/i)? image.file:fileIcon}/>)}
                                                        </Image.Group></div>
                                            </Segment>}
                {((reportDetails['inspection_type'] == "co") && reportDetails["ci_customer_service"] && reportDetails["ci_customer_service"].length > 0 ) && <Message negative header="CI Customer Service Found" content=" The Check In Report has had additional customer service submissions, please download the check in PDF to consult the customer service additions, and take them into account when compiling this check out"></Message>}
                <Segment>
                    <ReportTitlePage reportId={reportDetails.id} titleImage={reportDetails.title}/>
                </Segment>
                {reportDetails["report_type"] === "other" && <Segment> <OriginalReportDetails other_template_name={reportDetails.other_template_name} other_template_date={reportDetails.other_template_date} other_soc={reportDetails.other_soc} other_template_link={reportDetails.other_template_link} original_soc_available={reportDetails.original_soc_available}reportId={reportDetails.id} /></Segment>}
                <Segment>
                    {reportDetails && <RoomsListView rooms={reportDetails.rooms}
                                                     reportType={reportDetails['inspection_type']}
                                                     reportId={reportDetails.id}
                                                     showSaveAsTemplate={this.showSaveTemplate}
                                                     showLoadFromTemplate={this.showLoadTemplate}
                                                     openSelection={this.openSelection}
                                                     initUploadImages={this.setUploadingImages}
                                                     showPasswordWindow={this.showEnterPasswordWindow}
                                                     other_template={reportDetails["report_type"] === "other" ? true : false}
                    />
                    }
                </Segment>
                <Segment>
                    <ScheduleOfCondition reportId={reportDetails.id} reportDetails={reportDetails} />
                </Segment>
{this.props.userRole == "admin" && <Segment>
                    <PhotoLink photoLink={reportDetails['photo_link']} reportId={reportDetails.id}/>
                </Segment>}
                <Segment textAlign="center">{this.state.showAdditionalPhotos && !this.props.isFetching ? <AdditionalPhotos forceOverlay={this.state.forceOverlay} inspection_id={this.props.reportDetails['inspection_id']} /> : <Segment><Button className="bottom-margin" icon primary onClick={() => { this.setState({ showAdditionalPhotos: true }) }} ><Icon name="upload"/> Show Additional Photos Uploader </Button><Button  id="show_overlay_button" icon  onClick={() => { this.setState({ showAdditionalPhotos: true,forceOverlay:true }) }} ><Icon name="camera" /> Show Photos Overlay </Button><Message warning>The recommended way to capture photos at the property is using the live camera feature on the images overlay, which uploads photos immediately as they are taken. This is even more important if you plan to complete the report at the property. Do not add images directly through interacting with the drag&drop zones if you are on mobile. Explanatory video - <a href="https://www.youtube.com/watch?v=xDHGfF7uVaA">https://www.youtube.com/watch?v=xDHGfF7uVaA</a></Message></Segment>}</Segment>
            </Segment>
            <FloatingSideBarWidget openSelection={this.openSelection}
                                   reportType={reportDetails['inspection_type']}
                                   reportId={reportDetails.id}
                                   initUploadImages={this.setUploadingImages}
                                   showPasswordWindow={this.showEnterPasswordWindow}
                                   other_template={reportDetails["report_type"] === "other" ? true : false}
            />
            {this.state.uploadImages &&
            <ImageUploadProgress openModal={this.state.uploadImages} completeUpload={this.setUploadingImages}/>}
            {this.state.showSelection === 'keys' &&
                <Keys inspectionId={reportDetails['inspection_id']} showKeys={this.state.showSelection === 'keys'} handleClose={this.handleClose} other_template={reportDetails["report_type"] === "other" ? true : false}/>}
            {this.state.showSelection === 'meters' &&
                <Meters showMeters={this.state.showSelection === 'meters'} handleClose={this.handleClose} other_template={reportDetails["report_type"] === "other" ? true : false}/>}
            {this.state.showSelection === 'alarms' &&
            <Alarms showAlarms={this.state.showSelection === 'alarms'} handleClose={this.handleClose}/>}
            {this.state.showSelection === 'receipts' &&
            <Receipt showReceipts={this.state.showSelection === 'receipts'} handleClose={this.handleClose}/>}
            {this.state.showSelection === 'disclaimer' &&
                <DisclaimerNotes showDisclaimer={this.state.showSelection === 'disclaimer'} handleClose={this.handleClose} />}
            {this.state.showSelection === 'depositary' &&
                <Depositary showDepositary={this.state.showSelection === 'depositary'} completeReport={ this.submitReport} handleClose={this.handleClose}/>}
            {this.state.showSelection === 'transcription' &&
                <AutoTranscription other_template={reportDetails["report_type"] === "other"}showTranscription={this.state.showSelection === 'transcription'} handleClose={this.handleClose}/>}
                  {this.state.showSelection === 'checklist' &&
            <Checklist showChecklist={this.state.showSelection === 'checklist'} userRole={this.props.userRole} completeReport={ this.submitReport} handleClose={this.handleClose}/>}
             {/* {this.state.showSelection === 'roomsort' && <RoomSort showRoomSort={this.state.showSelection === 'roomsort'} handleClose={this.handleClose}/>} */}
            {this.state.showSelection === 'summary_notes' && <AdditionalSummary showAdditionalSummary={this.state.showSelection === 'summary_notes'} handleClose={this.handleClose}/>}
            {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
            {this.state.saveAsTemplate && <ClerkRoomTemplate roomObject={this.state.roomSelectedForTemplate} showSaveAsTemplate={this.showSaveTemplate}/>}
            {this.state.showRoomTemplate && <RoomTemplateList other_template={reportDetails["report_type"] === "other" } showLoadRoomTemplate={this.showLoadTemplate} loadTemplate={this.loadSelectedTemplate}/>}
            {this.state.showPasswordWindow && <LoginModal reLogin={(email, password,otp_attempt) => {this.validateLogin(email,password,otp_attempt)}} messages={this.state.loginError} reloggingin={this.state.loggingin}/>}
              <Popup  on="click" wide="very" hideOnScroll trigger={<Button icon  compact  style={{ zIndex:1001,position: "fixed", bottom: "10px", left: "20px" }}>   <Icon name="location arrow" />Scroll</Button>}
              content={ <div style={{margin:"auto",textAlign:"center"}}> <Button fluid icon compact onClick={()=>{   window.scrollTo({top: 0, behavior: "smooth"});}}>   <Icon name="chevron up" /> Scroll To Top</Button>
              <hr/> <Button fluid compact onClick={()=>{   window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth"});}}> <Icon name="chevron down" />  Scroll To Bottom</Button></div>}/>
        </div>);
    }
}

export default ReportContainer(CreateReport);


// WEBPACK FOOTER //
// ./src/views/report/create_report.js